import { render, staticRenderFns } from "./ViewProfileGroup.vue?vue&type=template&id=0d4cd192&scoped=true"
import script from "./ViewProfileGroup.vue?vue&type=script&lang=js"
export * from "./ViewProfileGroup.vue?vue&type=script&lang=js"
import style0 from "./ViewProfileGroup.vue?vue&type=style&index=0&id=0d4cd192&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4cd192",
  null
  
)

export default component.exports